<template>
  <button
    :class="cl(
      'x-button',
      type,
      size,
      sharp,
      disabled,
      bold,
      bolder
    )"
    :disabled="disabled"
    :type="nativeType"
    @click="$emit('click')"
  >
    <span class="x-button__text"><slot></slot></span>
  </button>
</template>

<script>
export default {
  props: {
    type: {
      validator(value) {
        return ['default', 'primary', 'warning', 'danger', 'brilliant', 'text', 'icon'].indexOf(value) !== -1;
      },
      default: 'default',
    },
    size: {
      validator(value) {
        return ['default', 'large', 'small', 'mini'].indexOf(value) !== -1;
      },
      default: 'default',
    },
    sharp: Boolean,
    disabled: Boolean,
    bold: Boolean,
    bolder: Boolean,
    nativeType: {
      validator(value) {
        return ['submit', 'button', 'reset'].indexOf(value) !== -1;
      },
      default: 'button',
    },
  },

  methods: {
    cl(
      block,
      type,
      size,
      sharp,
      disabled,
      bold,
      bolder,
    ) {
      const result = [block];
      if (type !== 'default') result.push(`${block}--${type}`);
      if (size !== 'default') result.push(`${block}--${size}`);
      if (bold) result.push(`${block}--bold`);
      if (bolder) result.push(`${block}--bolder`);
      if (sharp) result.push(`${block}--sharp`);
      if (disabled) result.push(`${block}--disabled`);
      return result.join(' ');
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/assets/less/variable";
@import "~@/assets/less/mixin";

.x-button {
  position: relative;
  display: inline-block;
  height: 32px;
  line-height: 32px;
  border-radius: 8px;
  box-sizing: border-box;
  text-align: center;
  user-select: none;
  -webkit-appearance: none;

  padding: 0 15px;
  font-size: 15px;

  transition: all .25s;
  cursor: pointer;

  &:hover {
    .brightness;
  }

  &:focus {
    outline: none;
  }

  &::before {
    content: " ";
    position: absolute;
    top: 50%;
    left: 50%;
    opacity: 0;
    width: 100%;
    height: 100%;
    border: inherit;
    border-color: @black;
    background-color: @black;
    border-radius: inherit;
    transform: translate(-50%, -50%);
  }

  &:active::before {
    opacity: .3;
  }

  // &--default {
  // }

  &--primary {
    color: @button-primary-color;
    background-color: @button-primary-background-color;
    border: 1px solid @button-primary-border-color;
  }

  &--warning {
    color: @button-warning-color;
    background-color: @button-warning-background-color;
    border: 1px solid @button-warning-border-color;
  }

  &--brilliant {
    color: @button-brilliant-color;
    background-color: @button-brilliant-background-color;
    border: 1px solid @button-brilliant-border-color;
  }

  &--text,
  &--icon {
    color: @button-text-color;
    background-color: transparent;
    border: none;
    &::before {
      display: none;
    }
  }

  // &--danger {
  // }

  &--large {
    height: 62px;
    font-size: 18px;
    line-height: 60px;
    border-radius: 16px;
  }

  // OJ按钮
  &--small {
    width: 130px;
    height: auto;
    font-size: 14px;
    line-height: 25px;
    border-radius: 15px;
    background: transparent;
  }

  &--mini {
    min-width: 106px;
    padding: 0 16px;
    height: 32px;
    font-size: 16px;
    line-height: 30px;
    border-radius: 16px;
  }

  &--icon {
    min-width: 20px;
    padding: 0 3px;
  }

  &--bold {
    font-weight: 500;
  }

  &--bolder {
    font-weight: 600;
  }

  &--sharp {
    border-radius: 0;
  }

  &--disabled {
    filter: brightness(0.9) !important;
    cursor: not-allowed;
    &:active::before {
      opacity: 0;
    }
  }
}
</style>
